<template>
  <div class="list">
    <el-col>
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" class="demo-inline-form" :model="search_form">
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="comeTime"
              type="datetimerange"
              align="right"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input
              style="width:160px;"
              v-model="search_form.FMerchantId"
              auto-complete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="认证状态">
            <el-select v-model="search_form.FStatus" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="(item,index) in statusList" :value="index" :label="item" :key="index" v-show="item !== ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="search"
              :loading="checkLoading"
              label="查询"></auth-button>
            <auth-button opt="submit" @click.native="submitCertification" label="提交认证"></auth-button>
            <auth-button opt="refresh_status" :loading="refreshLoading"  @click.native="refreshStatus" label="刷新认证状态"></auth-button>
          </el-form-item>
        </el-form>
        <p>注：刷新认证状态只刷新当前分页的商户，如需刷新其他商户，请切换到其他分页</p>
      </el-card>
    </el-col>
    <el-dialog title="提交认证" v-if="certificateDialogVisible" :visible.sync="certificateDialogVisible" width="500px">
      <div class="marginBtm">
        <el-radio v-model="certificateType" :label="0">
          <span class="type">单个申请</span>
          <el-input v-model="certificateForm.merchantId" placeholder="请输入商户编号" :disabled="certificateType === 1"></el-input>
        </el-radio>
      </div>
      <div>
        <el-radio v-model="certificateType" :label="1">
          <span class="type">批量申请</span>
          <a href="static/批量提交认证申请模板.xlsx" download="批量提交认证申请模板.xlsx"><el-button size="small" type="primary">下载模板文件</el-button></a>
          <input type="file" id="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
          <el-button
            type="primary"
            plain
            size="small"
            class="check"
            @click="getCertificationFiles()"
            :disabled="certificateType === 0">批量导入</el-button>
          <el-col v-if="certificateFileName !== ''" class="hasSelect">
            <span>已选择: {{ certificateFileName }}</span>
            <i class="el-icon-remove removeIcon" @click="removeFile"></i>
          </el-col>
        </el-radio>
      </div>

      <div slot="footer">
        <el-button type="primary" size="small" @click="certificate" :loading="buttonLoading">确认提交</el-button>
        <el-button size="small" @click="certificateDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-card class="tableCard" shadow="never">
      <el-table stripe style="width: 100%;" v-loading="loading" :data="list" :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fCreateTime"
          label="申请时间"
          width="180px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          width="180px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户全称"
          width="150px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fApplymentId"
          label="申请单号"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fApplymentId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="认证状态"
          width="120px"
          :formatter="fStatusType"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fRejectReason"
          label="错误原因"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fRejectReason || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="信息确认二维码"
          width="140"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="download"
              size="small"
              :loading="buttonLoading"
              @click.native="downLoadQrcode(scope.row)"
              v-if="scope.row.fQrcode!==''"
              label="下载二维码"></auth-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="授权详情"
          width="160"
          align="center">
          <template slot-scope="scope">
            <auth-button opt="authorize" @click.native="authorizeDetails(scope.row)" size="small" label="微信商户号授权"></auth-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="操作"
          width="250"
          align="center">
          <template slot-scope="scope">
            <auth-button opt="cancel_order" @click.native="cancelApply(scope.row)" size="small" label="撤销申请"></auth-button>
            <auth-button opt="resubmit" @click.native="resubmit(scope.row)" size="small" label="重新提交"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog :visible.sync="authorizeDialogVisible" title="授权详情查看" v-if="authorizeDialogVisible" width="500px">
      <el-table
        border
        style="width:80%;margin: 0 auto;"
        :data="authorizeList"
        v-loading="loading">
        <el-table-column
          label="微信渠道号"
          prop="fChannelId"
          align="center">
        </el-table-column>
        <el-table-column
          label="微信商户号"
          prop="fWxSubMchId"
          align="center">
        </el-table-column>
        <el-table-column
          label="授权状态"
          prop="fStatus"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.fAuthorizeState === '0'">未授权</span>
            <span v-if="scope.row.fAuthorizeState === '1'">已授权</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pageAuthorize.total>0"
        class="pagination"
        :page-sizes="pageAuthorize.pageSizes"
        :page-size="pageAuthorize.pageSize"
        :layout="pageAuthorize.layout"
        :total="pageAuthorize.total"
        :pageNum="pageAuthorize.pageNum"
        @current-change="onChangeAuthorizePage">
      </el-pagination>
    </el-dialog>
    <el-dialog title="批量提交认证完成" :visible.sync="batchResultDialogVisible" center>
      <p class="marginBtm">成功{{ successNum }}条，失败{{ failNum }}条</p>
      <el-table border size="small" :data="batchData">
        <el-table-column prop="merchantId" label="商户编号" width="120" align="center"></el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchResultDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { scheduleCheckList, subMerchantCheckList, cancelApplyWx, certificateCommit, refreshStatus } from '@/api/channel'
import api from '@/api/index'
export default {
  name: 'CertificationInfo',
  data () {
    return {
      comeTime: [],
      search_form: {
        FStartTime: '',
        FEndTime: '',
        FMerchantId: '', // 商户编号
        FStatus: '', // 认证状态
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      statusList: ['待上报', '上报失败', '待微信审核', '', '待联系人确认', '待法人确认', '审核通过', '审核退回', '冻结', '已作废'],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setHours(0)
            start.setMinutes(0)
            start.setSeconds(0)
            end.setHours(23)
            end.setMinutes(59)
            end.setSeconds(59)
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      loading: false, // 表格加载
      checkLoading: false, // 查询加载
      list: [], // 表格数据
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      certificateDialogVisible: false, // 提交认证弹窗展示
      // 提交认证表单
      certificateForm: {
        merchantId: ''// 商户编号
      },
      certificateType: 0, // 提交认证类型0为单个，1为批量
      buttonLoading: false, // 按钮加载
      authorizeDialogVisible: false, // 授权详情列表弹窗展示
      authorizeList: [], // 授权详情列表
      authorizeNum: '', // 授权详情列表总数
      // 授权详情列表查询表单
      authorizeForm: {
        FMerchantId: '',
        pageNo: 1,
        Count: 0
      },
      // 授权详情列表分页
      pageAuthorize: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      certificateFile: '', // 批量提交认证申请上传文件
      certificateFileName: '', // 批量提交认证申请上传文件名称
      batchResultDialogVisible: false, // 批量提交认证结果弹窗显示
      successNum: 0, // 批量提交认证成功数量
      failNum: 0,
      batchData: [], // 批量提交认证数据
      refreshLoading: false
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  },
  methods: {
    /**
             * @description 初始日期选择
             */
    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      start = start.getFullYear() + '-' + (((start.getMonth() + 1) < 10) ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)) + '-' + ((start.getDate() < 10) ? ('0' + start.getDate()) : (start.getDate())) + ' 00:00:00'
      end = end.getFullYear() + '-' + (((end.getMonth() + 1) < 10) ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)) + '-' + ((end.getDate() < 10) ? ('0' + end.getDate()) : (end.getDate())) + ' 23:59:59'
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
             * @description 日期选择器change事件
             */
    dateChange (value) {
      if (value !== null) {
        this.search_form.FStartTime = value[0]
        this.search_form.FEndTime = value[1]
      } else {
        this.search_form.FStartTime = ''
        this.search_form.FEndTime = ''
      }
    },
    /**
             * @description 提交认证
             */
    submitCertification () {
      this.certificateType = 0
      this.certificateForm.merchantId = ''
      this.certificateFile = ''
      this.certificateFileName = ''
      this.certificateDialogVisible = true
    },
    /**
             * @description 查询
             */
    search () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.getList()
    },
    /**
             * @description 获取列表数据
             */
    getList () {
      this.loading = true
      let data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      scheduleCheckList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.loading = false
          this.list = []
        } else {
          this.loading = false
          this.paginations.total = data.data.totalCount
          this.search_form.count = data.data.totalCount
          this.list = data.data.list
        }
      })
    },
    /**
             * @description 选择文件
             */
    getFile (event) {
      if (event.target.files[0].type !== 'application/vnd.ms-excel' && event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.certificateFile = event.target.files[0]
      this.certificateFileName = this.certificateFile.name
      event.target.value = null
    },
    /**
             * @description 选择批量认证文件
             */
    getCertificationFiles () {
      this.$jquery('#file').click()
    },

    /**
             * @description 授权详情查看
             */
    authorizeDetails (row) {
      this.authorizeDialogVisible = true
      this.authorizeForm.FMerchantId = row.fMerchantId
      this.authorizeForm.pageNo = 1
      this.authorizeForm.Count = 0
      this.getAuthorize()
    },
    /**
             * @description 获取授权详情列表
             * @param {String} id 商户id
             */
    getAuthorize () {
      this.loading = true
      let data = this.formatSearch(this.authorizeForm)
      data = qs.stringify(data)
      subMerchantCheckList(data).then((data) => {
        this.loading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.authorizeList = data.data.list
          this.pageAuthorize.total = data.data.totalCount
          this.authorizeNum = data.data.totalCount
        }
        this.loading = false
      })
    },
    /**
             * @description 改变授权认证当前页事件
             * @param  {number} page 当前页码
             */
    onChangeAuthorizePage (page) {
      const count = this.authorizeNum
      this.authorizeForm.pageNo = page
      this.authorizeForm.Count = count
      this.getAuthorize()
    },
    /**
             * @description 撤销申请
             */
    cancelApply (row) {
      this.$confirm('是否确认撤销申请商户【' + row.fMerchantName + '】', '提示', {}).then(() => {
        this.handlerStatus(row.fMerchantId)
      })
    },
    /**
             * @description 重新提交
             */
    resubmit (row) {
      const that = this
      this.$confirm('是否确认重新提交商户【' + row.fMerchantName + '】', '提示', {}).then(() => {
        that.certificateType = 0
        that.certificateForm.merchantId = row.fMerchantId
        that.certificate()
      })
    },
    /**
             * @description 撤销申请或重新提交申请
             *  @param {string} id 当前操作的商户id
             */
    handlerStatus (id) {
      let data = {
        merchantId: id
      }
      data = qs.stringify(data)
      cancelApplyWx(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.getList()
        }
        this.$message({
          showClose: true,
          message: data.error_msg,
          type: 'error'
        })
        this.buttonLoading = false
      }).catch(() => {
      })
    },
    /**
             * @description 改变当前页事件
             * @param  {number} page 当前页码
             */
    onChangeCurrentPage (page) {
      const count = this.search_form.count
      this.search_form.pageNo = page
      this.search_form.Count = count
      this.getList()
    },
    /**
             * @description 删除已上传文件
             */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.certificateFile = ''
        this.certificateFileName = ''
      })
    },
    /**
             * @description 提交认证提交
             */
    certificate () {
      if (this.certificateType === 0 && this.certificateForm.merchantId === '') {
        this.$message({
          message: '请先输入商户编号',
          type: 'warning'
        })
        return
      }
      if (this.certificateType === 1 && this.certificateFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      this.buttonLoading = true
      let data = {}
      if (this.certificateType === 0) {
        data = this.formatSearch(this.certificateForm)
        data.commitType = this.certificateType
        data = qs.stringify(data)
      } else {
        data = new FormData()
        data.append('commitType', this.certificateType)
        data.append('multipartFile', this.certificateFile)
      }
      certificateCommit(data).then((data) => {
        this.buttonLoading = false
        if (parseInt(data.error_code) !== 0) {
          if (this.certificateType === 0) {
            this.$message({
              showClose: true,
              message: data.result[0].reason,
              type: 'error'
            })
          } else {
            if (data.failure_num !== undefined) {
              this.successNum = data.success_num
              this.failNum = data.failure_num
              this.batchData = data.result
              this.batchResultDialogVisible = true
              this.certificateDialogVisible = false
              this.getList()
            } else {
              this.$message({
                showClose: true,
                message: data.error_msg,
                type: 'error'
              })
              this.certificateFile = ''
              this.certificateFileName = ''
            }
          }
        } else {
          // 批量提交认证
          if (this.certificateType === 1) {
            this.successNum = data.success_num
            if (data.failure_num === 0) {
              this.$message({
                showClose: true,
                message: data.error_msg + '，成功导入' + data.success_num + '条',
                type: 'success'
              })
            }
          } else {
            // 单独一个商户提交认证
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'success'
            })
          }
          // 不管是不是批量，刷新列表，关闭提交认证弹窗
          this.getList()
          this.certificateDialogVisible = false
        }
      }).catch(() => {
        this.buttonLoading = false
      })
    },
    /**
             * @description 清除对象中无值属性
             */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
             * @description 授权状态对应文本
             * @param  {object} item 当前行数据
             */
    fStatusType (item) {
      var str
      switch (item.fStatus) {
        case 0: str = '待上报'; break
        case 1: str = '上报失败'; break
        case 2: str = '待微信审核'; break
          // case 3: str = "编辑中";break;
        case 4: str = '待联系人确认'; break
        case 5: str = '待法人确认'; break
        case 6: str = '审核通过'; break
        case 7: str = '审核退回'; break
        case 8: str = '冻结'; break
        case 9: str = '已作废'; break
        default: str = ''
      }
      return str
    },
    /**
             * @description 下载信息确认二维码
             * @param  {object} row 当前行数据
             */
    downLoadQrcode (row) {
      this.buttonLoading = true
      var p = api.host
      window.location.href = p + '/wechat-certificate/down-load-pic?FQrcode=' + row.fQrcode
      this.buttonLoading = false
    },
    /**
     * @description 刷新当前分页的认证状态
     */
    refreshStatus () {
      this.refreshLoading = true
      const merchantIds = this.list.map(item => {
        return item.fMerchantId
      }).join(',')
      const data = qs.stringify({
        merchantIds: merchantIds
      })
      refreshStatus(data).then(res => {
        this.refreshLoading = false
        if (res.error_code === '0') {
          this.getList()
        } else {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .marginBtm{
        margin-bottom: 20px;
    }
    .type{
        margin-right: 10px;
    }
    .pagination{
        margin: 20px 0;
        text-align: center;
    }
    .hasSelect{
        font-size: 15px;
        margin-top: 20px;
        color: #606266;
    }
    .hasSelect span{
        float: left;
        margin-bottom: 20px;
        line-height: 30px;
        display: inline-block;
        max-width: 430px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .hasSelect .removeIcon{
        color:#F56C6C;
        line-height: 30px;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
